import Immutable from 'immutable';

export default Immutable.fromJS({
  isActive     : false,
  isSuccessful : false,
  questions    : [],
});
